
    import EducationCard from '@/components/Education/EducationCard';
    import Slide from '@/components/Utils/Slide';

    export default {
        name: 'EducationSlider',

        components: {
            Slide,
            EducationCard,
        },

        props: {
            articles: {
                type: Array,
                default: () => ([]),
            },
        },

        data() {
            return {
                breakpoints: {
                    320: {
                        perView: 1,
                        peek: 16,
                    },

                    576: {
                        perView: 2,
                        peek: 16,
                    },

                    768: {
                        perView: 2,
                        peek: 24,
                    },

                    808: {
                        perView: 3,
                        peek: 32,
                    },

                    1280: {
                        perView: 3,
                        peek: 64,
                    },

                    1920: {
                        perView: 5,
                        peek: 64,
                    },

                    2400: {
                        perView: 5,
                        peek: 64,
                    },
                },
            };
        },

        computed: {
            getBreakPoints() {
                const newBreakPoints = this.breakpoints;
                if (this.$route.path === '/discover') {
                    newBreakPoints['1280'].perView = 4;
                }
                return newBreakPoints;
            },
        },

        methods: {
            onSelectArticle(article) {
                this.$emit('select', article);
            },
        },
    };
